import {
  preEnrolSuccess,
  getPreEnrolSuccess,
  getSinglePreEnrolSuccess,
  isPending,
  preEnrolFail,
} from "././preEnrolmentSlice";
import preEnrolAPI from "../../apis/preEnrollApi";
import { toast } from "react-toastify";
import enrolAPI from "../../apis/enrollAPI";

export const newPreEnrolmentAction = (obj) => async (dispatch) => {
  dispatch(isPending(true));

  const result = await preEnrolAPI.createNewPreEnrol(obj);
  result.status === "success"
    ? dispatch(preEnrolSuccess(result.result)) && toast.success(result.message)
    : dispatch(preEnrolFail() && toast.error(result.message));
};

export const addInstallmentAction = (obj) => async (dispatch) => {
  dispatch(isPending(true));

  const result = await preEnrolAPI.addInstallment(obj);
  result.status === "success"
    ? dispatch(preEnrolSuccess(result.result))
    : dispatch(preEnrolFail());
};

export const updatePreEnrolmentAction = (_id, update) => async (dispatch) => {
  if (!_id) return;
  dispatch(isPending());
  const result = await preEnrolAPI.updatePreEnrol(_id, update);

  result.status === "success"
    ? dispatch(preEnrolSuccess(result.result)) &&
      toast.success("Pre-Enrolment Updated Successfully")
    : toast.warn("Something went wrong! Please try again later.") &&
      dispatch(preEnrolFail());
};

export const fetchPreEnrolsAction = (params) => async (dispatch) => {
  dispatch(isPending());

  if (params !== "branch=all") {
    const result = await preEnrolAPI.fetchLocationPreEnrols(params);
    result.status === "success"
      ? dispatch(getPreEnrolSuccess(result.result)) &&
        toast.success(result.message)
      : toast.warn(result.message) && dispatch(preEnrolFail());
    return;
  }

  const result = await preEnrolAPI.fetchPreEnrols();

  result.status === "success"
    ? dispatch(getPreEnrolSuccess(result.result)) &&
      toast.success(result.message)
    : toast.warn(result.message) && dispatch(preEnrolFail());
};

export const fetchLocationPreEnrolsAction = (params) => async (dispatch) => {
  dispatch(isPending());

  const result = await preEnrolAPI.fetchLocationPreEnrols(params);
  result.status === "success"
    ? dispatch(getPreEnrolSuccess(result.result)) &&
      toast.success(result.message)
    : toast.warn(result.message) && dispatch(preEnrolFail());
};

export const fetchSinglePreEnrolAction = (_id) => async (dispatch) => {
  if (!_id) return;

  dispatch(isPending());

  const result = await preEnrolAPI.fetchPreEnrols(_id);

  result.status === "success"
    ? dispatch(getSinglePreEnrolSuccess(result.result)) &&
      dispatch(preEnrolSuccess(result))
    : toast.warn(result.message) && dispatch(preEnrolFail());
};

export const deletePreEnrolAction = (_id, branch) => async (dispatch) => {
  dispatch(isPending());
  const params = `branch=${branch}`;
  const result = await preEnrolAPI.deleteAPreEnrol(_id);

  result.status === "success"
    ? dispatch(fetchPreEnrolsAction(params)) && toast.success(result.message)
    : toast.warn(result.message);
};

export const addNoteFromPreEnrolment = (obj) => async (dispatch) => {
  dispatch(isPending());

  const { params, ...rest } = obj;

  const result = await preEnrolAPI.addPreEnrolmentNote(rest);

  result.status === "success"
    ? toast.success(result.message) && dispatch(fetchPreEnrolsAction(params))
    : toast.warning(result.message);
};
